import { useState } from 'react'
import { useAuth } from '../lib/auth'
import { ArrowLeft, Save, Loader2, Lock } from 'lucide-react'
import { Link } from 'react-router-dom'

export default function ResidentSecurity() {
  const { token } = useAuth()
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm_password: '' })
  const [saving, setSaving] = useState(false)
  const [message, setMessage] = useState('')
  const [isError, setIsError] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setMessage('')
    if (form.new_password !== form.confirm_password) { setMessage('Passwords do not match'); setIsError(true); return }
    if (form.new_password.length < 8) { setMessage('Password must be at least 8 characters'); setIsError(true); return }
    setSaving(true)
    try {
      const res = await fetch('/api/auth/resident/change-password', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ current_password: form.current_password, new_password: form.new_password })
      })
      if (res.ok) { setMessage('Password changed successfully!'); setIsError(false); setForm({ current_password: '', new_password: '', confirm_password: '' }) }
      else { const err = await res.json(); setMessage(err.detail || 'Failed'); setIsError(true) }
    } catch { setMessage('Network error'); setIsError(true) }
    finally { setSaving(false) }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-4">
          <Link to="/" className="text-gray-500 hover:text-gray-700"><ArrowLeft className="w-5 h-5" /></Link>
          <h1 className="text-lg font-semibold text-gray-900">Security Settings</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8">
        <form onSubmit={handleSubmit} className="bg-white rounded-xl shadow-sm p-6 max-w-md">
          <div className="flex items-center gap-3 mb-6">
            <Lock className="w-6 h-6 text-gray-400" />
            <h2 className="font-medium text-gray-900">Change Password</h2>
          </div>
          {message && <div className={`mb-4 p-3 rounded-lg text-sm ${isError ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-green-50 text-green-700 border border-green-200'}`}>{message}</div>}
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Current Password</label>
              <input type="password" value={form.current_password} onChange={(e) => setForm({...form, current_password: e.target.value})} className="w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-primary-500 outline-none" required />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
              <input type="password" value={form.new_password} onChange={(e) => setForm({...form, new_password: e.target.value})} className="w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-primary-500 outline-none" required minLength={8} />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Confirm New Password</label>
              <input type="password" value={form.confirm_password} onChange={(e) => setForm({...form, confirm_password: e.target.value})} className="w-full px-4 py-2.5 border rounded-lg focus:ring-2 focus:ring-primary-500 outline-none" required />
            </div>
          </div>
          <div className="mt-6">
            <button type="submit" disabled={saving} className="flex items-center gap-2 px-6 py-2.5 bg-primary-600 hover:bg-primary-700 text-white rounded-lg disabled:opacity-50">
              {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} {saving ? 'Saving...' : 'Change Password'}
            </button>
          </div>
        </form>
      </main>
    </div>
  )
}
